import resolveReference from './resolveReference';

const resolveReferences = <T = unknown>({
  rawVal = [],
  page,
}: PropsWithCMSProps<ReferencesProps>): T[] => {
  return rawVal
    ? (rawVal
        .map((val) => resolveReference({ rawVal: val, page }))
        .filter((content) => Boolean(content)) as T[])
    : [];
};

export default resolveReferences;
